/* ELVARA - runtime guards for Dawn bugs that throw in the wild.

   These patch Dawn's own classes at runtime rather than editing assets/global.js
   (48 KB, minified). Method names survive minification because the components are
   registered as custom elements, so the prototypes are reachable and this stays a
   small file instead of a risky whole-file rewrite. Re-check after a Dawn upgrade:
   if upstream fixes these, delete the corresponding block.

   ---------------------------------------------------------------------------
   1. SlideshowComponent.applyAnimationToAnnouncementBar - TypeError:
      "Cannot read properties of undefined (reading 'classList')"

      Dawn does:
        const currentIndex = this.currentPage - 1;
        const currentSlide = this.sliderItems[currentIndex];
        currentSlide.classList.add(...)

      currentPage is 1-based. When it is still 0 - the slider has not measured
      itself yet, which happens when layout is delayed or the bar starts
      off-screen - currentIndex is -1 and sliderItems[-1] is undefined. The
      announcement bar auto-rotates on EVERY page, so this fires site-wide, and it
      was 91% of the JS errors logged from the Instagram in-app browser, where
      webview layout timing makes the unmeasured state far more likely.

      The animation is cosmetic; the slide still changes. Bailing out is correct.

      ⚠ The index below MUST be computed exactly as Dawn computes it. A first
      version used `(this.currentPage || 1) - 1`, which turns the failing value 0
      into 1 - so the guard saw a valid index, passed through, and Dawn threw
      anyway. Verified by forcing currentPage = 0 and calling the method.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  if (!window.customElements || !customElements.whenDefined) return;

  customElements.whenDefined('slideshow-component').then(function () {
    var Klass = customElements.get('slideshow-component');
    if (!Klass || !Klass.prototype) return;
    if (Klass.prototype.elvAnnouncementGuard) return; // idempotent

    var original = Klass.prototype.applyAnimationToAnnouncementBar;
    if (typeof original !== 'function') return;

    Klass.prototype.applyAnimationToAnnouncementBar = function () {
      var items = this.sliderItems;
      var index = this.currentPage - 1; // mirrors Dawn exactly - see note above

      if (!items || !items.length || !items[index]) return;

      return original.apply(this, arguments);
    };

    Klass.prototype.elvAnnouncementGuard = true;
  });
})();
